import script from "./FastWatering.vue?vue&type=script&setup=true&lang=js"
export * from "./FastWatering.vue?vue&type=script&setup=true&lang=js"

import "./FastWatering.vue?vue&type=style&index=0&id=fe18da00&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fe18da00"]])

export default __exports__